import { render } from "./DialogTreeHome.vue?vue&type=template&id=18607e1c&scoped=true"
import script from "./DialogTreeHome.vue?vue&type=script&lang=js"
export * from "./DialogTreeHome.vue?vue&type=script&lang=js"

import "./DialogTreeHome.vue?vue&type=style&index=0&id=18607e1c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18607e1c"]])

export default __exports__